import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsHeatmap from 'highcharts/modules/heatmap';
import highchartsBoost from 'highcharts/modules/boost';
import { useAppContext } from '../../contexts/AppContext';
import { useMemo, useRef } from 'react';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import { asNamedSolutions, type ScreenSolution } from '../../types';
import { buildCleaningSchedulesOptions } from '../../utils/chartOptions/cleaningSchedules';

highchartsHeatmap(Highcharts);
highchartsBoost(Highcharts);

type Props = {
  data: ScreenSolution[];
  rain_dates: string[] | undefined;
};

const CompareCleaningSchedules = ({ data, rain_dates }: Props) => {
  const { isDarkMode } = useAppContext();
  const chartComponent = useRef(null);
  const isLoading = false;

  // isDarkMode is a dependency so the chart is redrawn after a theme switch.
  const chartOptions = useMemo(() => buildCleaningSchedulesOptions(asNamedSolutions(data), rain_dates), [data, rain_dates, isDarkMode]);

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        {isLoading ? (
          <Backdrop open={true} sx={{ width: '100%', height: '450px', position: 'relative' }}>
            <CircularProgress />
          </Backdrop>
        ) : (
          data &&
          chartOptions && (
            <>
              <HighchartsReact
                ref={chartComponent}
                containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
                highcharts={Highcharts}
                options={chartOptions}
              />
            </>
          )
        )}
      </Box>
    </>
  );
};

export default CompareCleaningSchedules;
